import React from "react"
import QuoteText from "../../QuoteText"
import CMSRender from "aldoo-ra/CMS/cms-render"

const renderQuoteIcon = (iconURL, direction, wSize, hSize) => {
  return (
    <div
      className={`w-[${wSize}px] h-[${hSize}px]
      ${direction === "up" ? "rotate-0" : "rotate-180"}
    `}
    >
      <img
        src={iconURL}
        alt="Quote Icon"
        style={{ width: `${wSize}px`, height: `${hSize}px` }}
      />
    </div>
  )
}

const renderAvatar = (image, index) => {
  return (
    <div
    key={index}
      className="w-[86px] h-[86px] border-white border-4 rounded-full overflow-hidden"
      style={{ zIndex: 4 - index }}
    >
      <img src={image} alt="Avatar" className="w-full h-auto" />
    </div>
  )
}

const renderItem = (item, id) => {
  return (
    <div 
      key={id}
      className="w-full flex justify-center bg-gradient_citation rounded-b-[50px] lg:rounded-b-[100px] px-[16px] md:px-px1_l lg:px-px1_xl xl:px-px1_xl py-[70px] md:py-[88px] xl:py-[116px] mb-[70px] md:mb-0"
    >
      <div className="flex flex-col-reverse md:flex-row w-full lg:max-w-w2_l xl:max-w-w2_xl items-center justify-between gap-[40px] lg:gap-4 mx-auto">
        {/* Left side: Avatar images */}
        <div className="flex space-x-[-22px] mr-auto lg:ml-0 lg:mb-6 mt-4 lg:mt-0">
          {item.avatars?.map(renderAvatar)}
        </div>

        {/* Right side */}
        <div className="flex flex-col items-end justify-center gap-[30px] md:gap-[12px]">
          {/* Oxford Languages Logo */}
          <div className="w-[320px] md:w-[371px] aspect-371/58">
            <img src={item.logo} alt="Powered by Oxford Languages" />
          </div>

          <QuoteText
            text={item.quote?.[0]?.quote_text}
            quoteUp={renderQuoteIcon(item.quote?.[0]?.quote, "up", 50, 40)}
            quoteDown={renderQuoteIcon(item.quote?.[0]?.quote, "down",24, 20)}
          />
        </div>
      </div>
    </div>
  )
}

const CitationSection = () => {
  return (
    <CMSRender
      contentType={"CitationSection"}
      match={{ "content.name": "OxfordLanguagesCitationSection" }}
      renderItem={renderItem}
    />
  )
}

export default CitationSection
